var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1940_25443)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 14,
    fill: "#FEF7E1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1940_25443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 18C8 14.6863 10.6863 12 14 12H51C54.3137 12 57 14.6863 57 18V77H8V18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 29,
    r: 3,
    fill: "#E60A2B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 26,
    width: 20,
    height: 6,
    fill: "#FEE7EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 26,
    width: 11,
    height: 6,
    fill: "#FEF0F2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 39,
    r: 3,
    fill: "#0EA3FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 36,
    width: 20,
    height: 6,
    fill: "#E1F3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 36,
    width: 11,
    height: 6,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 49,
    r: 3,
    fill: "#F9C320"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 46,
    width: 20,
    height: 6,
    fill: "#FEF7E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 46,
    width: 11,
    height: 6,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 59,
    r: 3,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 56,
    width: 20,
    height: 6,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 56,
    width: 11,
    height: 6,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16,
    width: 17,
    height: 6,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 18,
    width: 11,
    height: 2,
    fill: "#F5F5F5"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 64.4,
    height: 64.4,
    rx: 13.7,
    stroke: "#FDEDBE",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1940_25443",
    x: -2,
    y: 6,
    width: 69,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1940_25443"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1940_25443",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1940_25443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiders);
export default __webpack_public_path__ + "static/media/riders.efe5af58b1d0a14389a3d001fb5483f7.svg";
export { ForwardRef as ReactComponent };